import React from "react";

import classNames from "classnames";

import DropdownPager from "./pager-components/DropdownPager";
import IconButton from "./pager-components/IconButton";
import NumberInput from "./pager-components/NumberInput";
import PageButton from "./pager-components/PageButton";
import RemoveAll from "./pager-components/RemoveAllButton";
import RemoveAllFavoritesEventsButton from "./pager-components/RemoveAllFavoritesEventsButton";
import RemoveAllFavoritesTournamentsButton from "./pager-components/RemoveAllFavoritesTournamentsButton";

export default function Pager(props: {
	pageNumber: number;
	pageSize: number;
	totalItems: number;
	onPageChange: (newPage: number) => void;
	isRemoveAllVisible?: boolean;
	onCloseAll?: () => void;
	withDropdown?: boolean;
	withNumberInput?: boolean;
	className?: string;
}) {
	const {
		pageNumber,
		pageSize,
		totalItems,
		onPageChange,
		isRemoveAllVisible,
		onCloseAll,
		withDropdown = false,
		withNumberInput = false,
		className,
	} = props;

	const remainder = totalItems % pageSize;

	const totalPages =
		remainder === 0
			? totalItems / pageSize
			: (totalItems - remainder) / pageSize + 1;

	if (totalPages <= 1) {
		return (
			<React.Fragment>
				<div className={classNames("pagination", className)}>
					{isRemoveAllVisible && (
						<RemoveAll onCloseAll={onCloseAll} />
					)}
					<RemoveAllFavoritesEventsButton />
					<RemoveAllFavoritesTournamentsButton />
				</div>
			</React.Fragment>
		);
	}

	let start = 1;
	let end = totalPages;

	if (totalPages > 3) {
		end = 3;
	}

	if (totalPages > 3 && pageNumber > 1) {
		start = pageNumber - 1;
		end = pageNumber + 1;

		if (end > totalPages) {
			end = totalPages;
			start = totalPages - 2;
		}
	}

	const renderInnerPager = () => {
		const ip = [];

		for (let i = start; i <= end; ++i) {
			if (i === pageNumber) {
				ip.push(
					<PageButton
						key={i}
						page={i}
						onPageChange={onPageChange}
						disabled
						active
					/>
				);
			} else {
				ip.push(
					<PageButton key={i} page={i} onPageChange={onPageChange} />
				);
			}
		}

		return ip;
	};

	const paginationTabsClasses = classNames("pagination__tabs", {
		"pagination__tabs--sml": withNumberInput,
	});

	return (
		<React.Fragment>
			<nav className={classNames("pagination", className)}>
				<div className={paginationTabsClasses}>
					{totalPages > 3 && pageNumber > 1 && start > 1 ? (
						<React.Fragment>
							<PageButton page={1} onPageChange={onPageChange} />
							<IconButton
								previous
								page={pageNumber - 1}
								onPageChange={onPageChange}
							/>
						</React.Fragment>
					) : null}

					{renderInnerPager()}

					{totalPages > 3 &&
					pageNumber < totalPages &&
					end < totalPages ? (
						<React.Fragment>
							<IconButton
								page={pageNumber + 1}
								onPageChange={onPageChange}
							/>
							<PageButton
								page={totalPages}
								onPageChange={onPageChange}
							/>
						</React.Fragment>
					) : null}
				</div>

				{withNumberInput && (
					<NumberInput
						totalPages={totalPages}
						onPageChange={onPageChange}
					/>
				)}

				{withDropdown && (
					<DropdownPager
						totalPages={totalPages}
						onPageChange={onPageChange}
						pageNumber={pageNumber}
					/>
				)}

				{isRemoveAllVisible && <RemoveAll onCloseAll={onCloseAll} />}

				<RemoveAllFavoritesEventsButton />
				<RemoveAllFavoritesTournamentsButton />
			</nav>
		</React.Fragment>
	);
}
